"use client";

import { useEffect } from "react";
import { subscribeAppBoot } from "@/lib/progress";

export function PageLoader() {
  useEffect(() => {
    const el = document.getElementById("kairos-page-loader");
    if (!el) return;

    return subscribeAppBoot(() => {
      el.setAttribute("aria-busy", "false");
      el.classList.add("is-hiding");
      window.setTimeout(() => {
        el.classList.remove("is-visible", "is-hiding");
      }, 320);
    });
  }, []);

  return null;
}
